<template>
    <section class="authentication-form">
      <div>
        <h2 class="title text-center">
          RESET YOUR<span> PASSWORD</span>
        </h2>
        <div class="card">
          <form
            class="theme-form"
            @submit.prevent
          >
            <div class="form-group mt-2">
              <h6 class="mt-0 mb-3">
                Enter your email:
              </h6>
              <div class="form-row">
                <div class="col-12">
                  <input
                    v-model="input.email"
                    type="email"
                    class="form-control"
                    placeholder="someone@someone.com"

                  >
                </div>
                <div class="col-12 mt-4">
                  <button
                    type="submit"
                    class="btn btn-custom btn-block theme-color"
                    @click="forget"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery'
export default {
  name: 'ForgetPassword',
  data() {
    return {
      input: {
        email: null,
      },
    }
  },
  mounted: function() {
    $('.navbar').addClass('darkHeader')
  },
  methods: {
    forget() {
      this.axios
        .post(`${process.env.ROOT_API}/user/forgot/password`, {
          email: this.input.email,
        })
        .then(response => {
          this.$router.push({ name: 'AfterForgetPassword' })
        })
    },
  },
}
</script>
<style scoped>
.form-control{
  background-color: #d6fff1 !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/forget_password.vue